import { get, post, patch, del } from './request';

export const login = (email, password) =>
  post('login/', { email, password }, false);
export const signup = (data) => post('registration/', data, false);
export const forgot = (email) => post('password/reset/', { email }, false);
export const retrieveEmail = (uid, token) =>
  get(`retrieve_email/${uid}/${token}/`, false);
export const resetPassword = (data) =>
  post('password/reset/confirm/', data, false);
export const getConfirmEmail = (token) =>
  get(`register/confirm_email/${token}/`, false);
export const verifyEmailByToken = (data) =>
  post('register/verify_email/', data, false);
export const resendConfirmationLink = (data) =>
  post('register/resend_confirmation_link/', data, false);

export const getProfile = () => get('user/');
export const updateProfile = (profile) => patch('user/', profile);
export const getUser = (userId) => get(`users/${userId}/`);
export const updateUser = (user) => patch(`users/${user.id}/profile/`, user);
export const changePassword = (data) => post('password/change/', data);

export const getRoles = () => get('team_roles/');
export const getOwnershipTypes = () => get('ownership_types/', false);
export const getContractBlocks = () => get('contract_blocks/');
export const getWorkTypes = () => get('work_types/', false);
export const getSubWorkTypes = () => get('work_sub_types/', false);

export const getTeams = () => get('teams/');
export const getTeam = (id) => get(`teams/${id}/`);
export const createTeam = (team) => post(`teams/`, team);
export const updateTeam = (id, team) => patch(`teams/${id}/`, team);
export const deleteTeam = (id) => del(`teams/${id}/`);
export const archiveTeam = (id) => post(`teams/archive/${id}/`);
export const recoverTeam = (id) => post(`teams/recover/${id}/`);

export const getTeamMembers = (id) => get(`teams/${id}/users/`);
export const createTeamMember = (member) =>
  post(`teams/${member.team}/users/`, member);
export const updateTeamMember = (member) =>
  patch(`teams/${member.team}/users/${member.id}/`, member);
export const deleteTeamMember = (member) =>
  del(`teams/${member.team}/users/${member.id}/`);

export const createOwnership = (ownership) =>
  post(
    `teams/${ownership.team}/users/${ownership.team_user}/ownerships/`,
    ownership
  );
export const updateOwnership = (ownership) =>
  patch(
    `teams/${ownership.team}/users/${ownership.team_user}/ownerships/${ownership.id}/`,
    ownership
  );
export const deleteOwnership = (ownership) =>
  del(
    `teams/${ownership.team}/users/${ownership.team_user}/ownerships/${ownership.id}/`
  );

export const getAgreements = () => get('agreements/');
export const getAgreement = (id) => get(`agreements/${id}/`);
export const createAgreement = (agreement) => post(`agreements/`, agreement);
export const updateAgreement = (id, agreement) =>
  patch(`agreements/${id}/`, agreement);
export const deleteAgreement = (id) => del(`agreements/${id}/`);

export const getAgreementContractBlocks = (id) =>
  get(`agreements/${id}/contract_blocks/`);
export const saveAgreementContractBlock = (block) => {
  if (block.id) {
    return patch(
      `agreements/${block.agreement}/contract_block/${block.id}/`,
      block
    );
  } else {
    delete block.id;
    return post(`agreements/${block.agreement}/contract_blocks/`, block);
  }
};
export const createAgreementSentence = (sentence) =>
  post(`agreements/${sentence.agreement}/sentences/`, sentence);
export const updateAgreementSentence = (id, sentence) =>
  patch(`agreements/${sentence.agreement}/sentences/${id}/`, sentence);

export const getUserWorks = (userId) => get(`works/user/${userId}/`);
export const getWork = (id) => get(`works/${id}/`);
export const createWork = (work) => post(`works/`, work);
export const updateWork = (id, work) => patch(`works/${id}/`, work);
export const deleteWork = (id) => del(`works/${id}/`);

export const getWorkOwnerships = (workId) =>
  get(`works/${workId}/work_ownerships`);
export const getWorkOwnership = (workId, id) =>
  get(`works/${workId}/work_ownerships/${id}/`);
export const createWorkOwnership = (workOwnership) =>
  post(`works/${workOwnership.work}/work_ownerships/`, workOwnership);
export const updateWorkOwnership = (workOwnership) =>
  patch(
    `works/${workOwnership.work}/work_ownerships/${workOwnership.id}/`,
    workOwnership
  );
export const deleteWorkOwnership = (workOwnership) =>
  del(`works/${workOwnership.work}/work_ownerships/${workOwnership.id}/`);

export const getDeals = () => get('deals/');
export const getUserDeals = (id) => get(`deals/user/${id}/`);
export const getDeal = (id) => get(`deals/${id}/`);
export const createDeal = (deal) => post(`deals/`, deal);
export const updateDeal = (id, deal) => patch(`deals/${id}/`, deal);
export const deleteDeal = (id) => del(`deals/${id}/`);
export const getFinalizedDeals = (id) => get(`deals/user/${id}/finalized/`);

export const getInvites = (dealId) => get(`deals/${dealId}/invites/`);
export const getUserInvites = (id) => get(`deals/invites/user/${id}/`);
export const getInvite = (dealId, id) => get(`deals/${dealId}/invites/${id}/`);
export const createInvite = (dealId, data) =>
  post(`deals/${dealId}/invites/`, data);
export const updateInvite = (data) =>
  patch(`deals/${data.deal}/invites/${data.id}`, data);
export const deleteInvite = (dealId, id) =>
  del(`deals/${dealId}/invites/${id}/`);
export const getInviteByKey = (key) =>
  get(`deals/invites/public/${key}/`, false);
export const resendDealInvitation = (dealId, inviteId) =>
  get(`deals/${dealId}/invites/${inviteId}/resend/`);

export const getDealChanges = (dealId) => get(`deals/${dealId}/changes/`);
export const getDealChange = (dealChange) =>
  get(`deals/${dealChange.deal}/changes/${dealChange.id}/`);
export const createDealChange = (dealChange) =>
  post(`deals/${dealChange.deal}/changes/`, dealChange);
export const updateDealChange = (dealChange) =>
  patch(`deals/${dealChange.deal}/changes/${dealChange.id}/`, dealChange);
export const deleteDealChange = (dealChange) =>
  del(`deals/${dealChange.deal}/changes/${dealChange.id}/`);
export const notifyDealChange = (dealChange) =>
  post(`deals/${dealChange.deal}/notification/`, dealChange);
export const sendEmailToInviteeDealChange = (data) =>
  patch(`deals/changes/email/`, data);

export const getDealMessages = (dealId) => get(`deals/${dealId}/messages/`);
export const sendDealMessage = (data) =>
  post(`deals/${data.deal}/messages/`, data);
export const updateDealMessage = (dealId, id, data) =>
  patch(`deals/${dealId}/messages/${id}/`, data);
export const deleteDealMessage = (dealId, id) =>
  del(`deals/${dealId}/messages/${id}/`);

export const getDealUsers = (dealId) => get(`deals/${dealId}/users/`);
export const getDealUser = (dealUser) =>
  get(`deals/${dealUser.deal}/users/${dealUser.id}/`);
export const createDealUser = (dealUser) =>
  post(`deals/${dealUser.deal}/users/`, dealUser);
export const updateDealUser = (dealUser) =>
  patch(`deals/${dealUser.deal}/users/${dealUser.id}`, dealUser);
export const deleteDealUser = (dealUser) =>
  del(`deals/${dealUser.deal}/users/${dealUser.id}/`);

export const createCoregTemp = (coreg) => post(`coregs/temp/`, coreg);
export const createCoreg = (coreg) => post(`coregs/`, coreg);
export const updateCoreg = (coreg) => patch(`coregs/${coreg.id}/`, coreg);
export const createCoregFile = (coregFile) =>
  post(`coregs/${coregFile.coreg}/files/`, coregFile);
export const getCoregs = (userId) => get(`coregs/list/${userId}/`);
export const getCoregSnapshots = (coregId) => get(`coregs/${coregId}/snapshots`);

export const getClientToken = () => get(`payment/client_token/`);
export const checkout = (options) => post(`payment/checkout/`, options);
export const getCustomer = () => get(`payment/customer/`);
export const getSubscription = () => get(`payment/subscribe/`);
export const subscribe = (options) => post(`payment/subscribe/`, options);
export const cancelSubscribe = (options) => del(`payment/subscribe/`);
export const pay = (options) => post(`payment/transaction/`, options);
export const getSubscriptionPlans = (options) => get(`payment/plans/`, options);

export const verifyPhone = (data) => post(`phone_verify/`, data);
export const checkPhoneVerify = (data) => post(`phone_verify/check/`, data);

export const getPublishers = () => get(`publishers/`);
export const createPublisher = (publisher) => post(`publishers/`, publisher);
export const updatePublisher = (publisher) =>
  patch(`publishers/${publisher.id}/`, publisher);
export const deletePublisher = (publisher) => del(`publishers/${publisher.id}`);

export const getMarketingContent = (userId) =>
  get(`users/${userId}/marketing_content/`);
export const createMarketingContent = (data) =>
  post(`users/${data.user_id}/marketing_content/`, data);
export const updateMarketingContent = (data) =>
  patch(`users/${data.user_id}/marketing_content/${data.id}/`, data);
export const fixAgreementInviteIssue = (data) =>
  post(`fix_agreement_invite_issue/`, data);



// WEBPACK FOOTER //
// src/services/api.js